import { grey, red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

import { TOOLTIP_Z_INDEX } from '../constants/ui';

interface IThemeColors {
  primaryColor?: string | null;
  buttonColor?: string | null;
}

export const createDynamicTheme = ({ primaryColor, buttonColor }: IThemeColors = {}) => {
  const effectivePrimaryColor = primaryColor || '#5f11ea';
  const effectiveButtonColor = buttonColor || effectivePrimaryColor;

  return createTheme({
    palette: {
      primary: {
        main: effectivePrimaryColor,
      },
      background: {
        default: '#f5f5f5',
        paper: '#ffffff',
      },
      scrim: {
        zoomButton: 'rgba(255,255,255,0.9)',
      },
      accent: {
        button: effectiveButtonColor,
      },
    },

    spacing: 8,

    zIndex: {
      tooltip: TOOLTIP_Z_INDEX,
    },

    typography: {
      fontFamily: 'Gilroy, sans-serif',
      fontWeightRegular: 400,
      fontWeightBold: 500,
    },

    components: {
      MuiContainer: {
        defaultProps: {
          disableGutters: true,
          maxWidth: false,
        },
        styleOverrides: {
          root: {},
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            fontSize: 13,
            textTransform: 'none',
          },
          contained: {
            backgroundColor: effectiveButtonColor,
            '&:hover': {
              backgroundColor: effectiveButtonColor,
              opacity: 0.9,
            },
          },
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            backgroundColor: grey[100],
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            backgroundColor: 'white',
            '& input:-webkit-autofill': {
              backgroundColor: 'transparent !important',
              transition: 'background-color 5000s ease-in-out 0s',
            },
            '& input:-webkit-autofill:hover': {
              backgroundColor: 'transparent !important',
              transition: 'background-color 5000s ease-in-out 0s',
            },
            '& input:-webkit-autofill:focus': {
              backgroundColor: 'transparent !important',
              transition: 'background-color 5000s ease-in-out 0s',
            },
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          /* Red asterisk(*) when field is required */
          asterisk: {
            color: red[500],
          },
        },
      },
    },
  });
};
